/**
 * The game's bitmap font (spec 08 §2): 7x7 glyphs in 8x8 cells, two-pixel strokes, drawn in
 * the manner of the arcade's. Hand-placed pixels, as string grids ('#' on), because at this
 * size that is both tractable and reviewable. Used by the HUD canvas and, extruded into
 * voxels, by the letters inside the EXTEND bubbles.
 */

/** The menus' cursor, a glossy bubble; a character no text uses, so it has a glyph of its own. */
export const BUBBLE_GLYPH = '●';

const GLYPHS: Record<string, readonly string[]> = {
  A: ['..###..', '.##.##.', '##...##', '##...##', '#######', '##...##', '##...##'],
  B: ['######.', '##...##', '##...##', '######.', '##...##', '##...##', '######.'],
  C: ['..####.', '.##..##', '##.....', '##.....', '##.....', '.##..##', '..####.'],
  D: ['#####..', '##..##.', '##...##', '##...##', '##...##', '##..##.', '#####..'],
  E: ['#######', '##.....', '##.....', '######.', '##.....', '##.....', '#######'],
  F: ['#######', '##.....', '##.....', '######.', '##.....', '##.....', '##.....'],
  G: ['..#####', '.##....', '##.....', '##..###', '##...##', '.##..##', '..#####'],
  H: ['##...##', '##...##', '##...##', '#######', '##...##', '##...##', '##...##'],
  I: ['.######', '...##..', '...##..', '...##..', '...##..', '...##..', '.######'],
  J: ['....###', '.....##', '.....##', '.....##', '##...##', '##...##', '.#####.'],
  K: ['##...##', '##..##.', '##.##..', '####...', '#####..', '##..##.', '##...##'],
  L: ['##.....', '##.....', '##.....', '##.....', '##.....', '##.....', '#######'],
  M: ['##...##', '###.###', '#######', '#######', '##.#.##', '##...##', '##...##'],
  N: ['##...##', '###..##', '####.##', '##.####', '##..###', '##...##', '##...##'],
  O: ['.#####.', '##...##', '##...##', '##...##', '##...##', '##...##', '.#####.'],
  P: ['######.', '##...##', '##...##', '##...##', '######.', '##.....', '##.....'],
  Q: ['.#####.', '##...##', '##...##', '##...##', '##.####', '##..##.', '.####.#'],
  R: ['######.', '##...##', '##...##', '##..###', '#####..', '##.###.', '##..###'],
  S: ['.#####.', '##...##', '##.....', '.#####.', '.....##', '##...##', '.#####.'],
  T: ['.######', '...##..', '...##..', '...##..', '...##..', '...##..', '...##..'],
  U: ['##...##', '##...##', '##...##', '##...##', '##...##', '##...##', '.#####.'],
  V: ['##...##', '##...##', '##...##', '###.###', '.#####.', '..###..', '...#...'],
  W: ['##...##', '##...##', '##.#.##', '#######', '#######', '###.###', '##...##'],
  X: ['##...##', '###.###', '.#####.', '..###..', '.#####.', '###.###', '##...##'],
  Y: ['##...##', '##...##', '###.###', '.#####.', '..###..', '..###..', '..###..'],
  Z: ['#######', '....###', '...###.', '..###..', '.###...', '###....', '#######'],
  0: ['.#####.', '##...##', '##..###', '##.#.##', '###..##', '##...##', '.#####.'],
  1: ['...##..', '..###..', '.####..', '...##..', '...##..', '...##..', '.######'],
  2: ['.#####.', '##...##', '.....##', '...###.', '.###...', '##.....', '#######'],
  3: ['#######', '....##.', '...##..', '..####.', '.....##', '##...##', '.#####.'],
  4: ['...###.', '..####.', '.##.##.', '##..##.', '#######', '....##.', '....##.'],
  5: ['######.', '##.....', '######.', '.....##', '.....##', '##...##', '.#####.'],
  6: ['..####.', '.##....', '##.....', '######.', '##...##', '##...##', '.#####.'],
  7: ['#######', '##...##', '....##.', '...##..', '..##...', '..##...', '..##...'],
  8: ['.#####.', '##...##', '##...##', '.#####.', '##...##', '##...##', '.#####.'],
  9: ['.#####.', '##...##', '##...##', '.######', '.....##', '....##.', '.####..'],
  ' ': ['.......', '.......', '.......', '.......', '.......', '.......', '.......'],
  '!': ['..##...', '..##...', '..##...', '..##...', '..##...', '.......', '..##...'],
  '-': ['.......', '.......', '.......', '.#####.', '.......', '.......', '.......'],
  '.': ['.......', '.......', '.......', '.......', '.......', '.......', '..##...'],
  ':': ['.......', '..##...', '..##...', '.......', '..##...', '..##...', '.......'],
  '?': ['.#####.', '##...##', '....##.', '...##..', '...##..', '.......', '...##..'],
  "'": ['..##...', '..##...', '.##....', '.......', '.......', '.......', '.......'],
  '/': ['.....##', '....##.', '...##..', '..##...', '.##....', '##.....', '.......'],
  // Added for the menus (M3): the change list's punctuation, the options' values, the cursor.
  ',': ['.......', '.......', '.......', '.......', '..##...', '..##...', '.##....'],
  ';': ['.......', '..##...', '..##...', '.......', '..##...', '..##...', '.##....'],
  '(': ['...##..', '..##...', '.##....', '.##....', '.##....', '..##...', '...##..'],
  ')': ['..##...', '...##..', '....##.', '....##.', '....##.', '...##..', '..##...'],
  '+': ['.......', '...##..', '...##..', '.######', '...##..', '...##..', '.......'],
  '%': ['##...##', '##..##.', '...##..', '..##...', '.##....', '##...##', '.....##'],
  '&': ['..##...', '.##.##.', '..###..', '.###.##', '##.###.', '##..##.', '.###.##'],
  '"': ['.##.##.', '.##.##.', '##.##..', '.......', '.......', '.......', '.......'],
  '<': ['....##.', '...##..', '..##...', '.##....', '..##...', '...##..', '....##.'],
  '>': ['.##....', '..##...', '...##..', '....##.', '...##..', '..##...', '.##....'],
  [BUBBLE_GLYPH]: ['..###..', '.#####.', '##..###', '##.####', '#######', '.#####.', '..###..'],
};

/** Glyph size in pixels, and the advance from one character to the next. */
export const GLYPH = 7;
export const CELL = 8;

/** The glyph's rows ('#' = on) for `ch`, upper-cased; unknown characters draw as '?'. */
export function glyph(ch: string): readonly string[] {
  return GLYPHS[ch.toUpperCase()] ?? GLYPHS['?'] ?? [];
}

/** Every character the font has. */
export const FONT_CHARS: readonly string[] = Object.keys(GLYPHS);

/** Draws `text` at (x, y) (top-left, pixels) into a 2D context, `scale` pixels per font pixel. */
export function drawText(
  ctx: CanvasRenderingContext2D, text: string, x: number, y: number, colour: string, scale = 1,
): void {
  ctx.fillStyle = colour;
  [...text].forEach((ch, i) => {
    glyph(ch).forEach((row, r) => {
      for (let c = 0; c < row.length; c++) {
        if (row[c] === '#') ctx.fillRect(x + (i * CELL + c) * scale, y + r * scale, scale, scale);
      }
    });
  });
}

/** Width in pixels of `text` drawn at `scale`. */
export const textWidth = (text: string, scale = 1): number => text.length * CELL * scale;
